import * as React from 'react';
import { Layer } from 'react-map-gl';

import { ILoaderProps } from '../../../layer/ILoaderProps';
import { LoadableSource } from '../../../layer/LoadableSource';
import { Config } from '../../../../Config';

const NavigationRoutes = (props: ILoaderProps) => {
  return (
    <LoadableSource path="https://apigeostore.longline.co.uk/dataset/9c463d14593f565b94710dba49bf000690af33d6" ignore={['type']} {...props}>
      <Layer
        id='navigation_routes'
        beforeId={Config.UI.before_layer}
        type="line"
        layout={{ visibility: props.active ? "visible" : "none" }}          
        paint={{ 
          "line-color": "white",
          "line-width": [
            'interpolate',
            ['linear'],
            ["zoom"],
            0, 3,
            8, 5,
            18, 13
          ],
        }}        
      />
      <Layer
        id='navigation_routes_stroke'
        beforeId={Config.UI.before_layer}
        type="line"
        layout={{ visibility: props.active ? "visible" : "none" }}          
        paint={{ 
          "line-color": "steelblue",
          "line-width": [
            'interpolate',
            ['linear'],
            ["zoom"],
            0, 1,
            8, 2,
            18, 10
          ],
        }}
      />

    </LoadableSource>
  );
}

export { NavigationRoutes }

